import { decomposeColor, recomposeColor } from '@mui/material';
import { BlendColorsParams } from './blendColors.types';

export const blendColors = ({ background, overlay, opacity }: BlendColorsParams) => {
  const base = decomposeColor(background);
  const top = decomposeColor(overlay);

  return recomposeColor({
    type: 'rgb',
    values: [0, 1, 2].map((index) =>
      Math.round(base.values[index] + (top.values[index] - base.values[index]) * opacity),
    ) as [number, number, number],
  });
};
